import { render, staticRenderFns } from "./navigation-item.vue?vue&type=template&id=49a5f67a&"
import script from "./navigation-item.vue?vue&type=script&lang=ts&"
export * from "./navigation-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports